export type RevenueResponseDefaultOpenState = '' | 'conflicts' | 'succeed'

interface ResolveDefaultOpenStateInput {
  hasConflicts: boolean
  hasSuccess: boolean
}

export function resolveDefaultOpenState({
  hasConflicts,
  hasSuccess,
}: ResolveDefaultOpenStateInput): RevenueResponseDefaultOpenState {
  if (hasConflicts) {
    return 'conflicts'
  }

  if (hasSuccess) {
    return 'succeed'
  }

  return ''
}
